import { styled } from '@mui/material';

import { useMemo } from 'react';

import { TAppraisalDto } from '@app-velocity/av-api-v2';

import { AppraisalCategory } from '../AppraisalCategory';

import { AppraisalsCount } from '../../../ScreenAppraisals/components/AppraisalsCount';
import { useAppraisalContext } from '../../../../context/useAppraisalContext';

const StyledAppraisalHeader = styled('header')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  cursor: 'pointer',
});

export const AppraisalsContent = () => {
  const { reviews } = useAppraisalContext();

  const appraisalsByCategory = useMemo(() => {
    const byCategory: {
      [category: string]: {
        [slug: string]: TAppraisalDto[];
      };
    } = {};

    if (!reviews) return {};

    reviews.forEach((review) => {
      const { categoryName, rule } = review;

      // @TODO - rule to ruleSlug
      if (categoryName && rule) {
        if (!byCategory[categoryName]) byCategory[categoryName] = {};
        if (!byCategory[categoryName][rule])
          byCategory[categoryName][rule] = [];

        byCategory[categoryName][rule].push(review);
      }
    });

    return byCategory;
  }, [reviews]);

  const countByLevel = useMemo(() => {
    const byType: {
      [key in TAppraisalDto['level']]: number;
    } = {
      ERROR: 0,
      WARNING: 0,
      INFO: 0,
    };

    if (!reviews) return byType;

    for (const review of reviews) {
      byType[review.level]++;
    }

    return byType;
  }, [reviews]);

  if (!reviews || reviews.length === 0) return null;

  return (
    <>
      <StyledAppraisalHeader>
        <AppraisalsCount
          errors={countByLevel.ERROR}
          warnings={countByLevel.WARNING}
          info={countByLevel.INFO}
        />
      </StyledAppraisalHeader>
      {Object.keys(appraisalsByCategory).map((category) => (
        <AppraisalCategory
          key={category}
          reviews={appraisalsByCategory[category]}
        />
      ))}
    </>
  );
};
